import { render, staticRenderFns } from "./facilityobjectsinfo.vue?vue&type=template&id=45befc84&"
import script from "./facilityobjectsinfo.vue?vue&type=script&lang=js&"
export * from "./facilityobjectsinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45befc84')) {
      api.createRecord('45befc84', component.options)
    } else {
      api.reload('45befc84', component.options)
    }
    module.hot.accept("./facilityobjectsinfo.vue?vue&type=template&id=45befc84&", function () {
      api.rerender('45befc84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29WWMpi3zCEAy/JS/facilityobjectsinfo.vue"
export default component.exports